module.exports = __webpack_public_path__ + "img/pin.ebd212b4.svg";